export default function getShadowRootOrDocument(
  element: Element | null | undefined
) {
  // element가 없는 경우 document 반환
  if (!element) {
    return document;
  }

  // getRootNode()를 사용해 현재 요소의 루트 노드를 직접 얻음
  const rootNode = element.getRootNode();

  // ShadowRoot이거나 Document인 경우 해당 노드 반환
  if (rootNode instanceof ShadowRoot || rootNode instanceof Document) {
    return rootNode;
  }

  // 위 조건에 해당하지 않으면 document 반환
  return document;
}
